import "./AmountForm.css";

function AmountForm({ onSubmit }) {
  const handleSubmit = (e) => {
    e.preventDefault();

    if (typeof onSubmit === "function") {
      onSubmit();
    }
  };

  return (
    <form className="credit-card-form" onSubmit={handleSubmit}>
      <button className="primary-action" type="submit">
        Submit
      </button>
    </form>
  );
}

export default AmountForm;
